class NativeInstance {
	customInvoke(data) {
		const tp = new Date().getTime().toString()
		data = {
			type: 'customInvoke',
			...data,
			tp
		}
		// 发送消息
		uni.postMessage(
			{
				data
			},
			'*'
		)
		return new Promise((resolve, reject) => {
			window.invokeResolve = resolve
			window.invokeReject = reject
			window[`invokeResolve${tp}`] = resolve
			window[`invokeReject${tp}`] = reject
		})
	}
	invoke(data) {
		data = {
			type: 'invoke',
			...data
		}
		// 发送消息
		uni.postMessage(
			{
				data
			},
			'*'
		)
		return new Promise((resolve, reject) => {
			window.invokeResolve = resolve
			window.invokeReject = reject
		})
	}
}

let instance: any = null

export default () => {
	if (!instance) {
		instance = new NativeInstance()
	}
	return instance
}
